// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PBggt","title":"styles_title__0Stdz"};